import { useEffect } from 'react'
import { useLocation } from 'react-router'
import saveLayout from '../helpers/SaveLayout'
import { sessionStorageKeys } from '../utils/common'
import PropTypes from 'prop-types'

export const SaveRoute = ({ children, excepts }) => {
  const location = useLocation()

  useEffect(() => {
    if (excepts.every((route) => !location.pathname.includes(route))) {
      saveLayout.add(
        sessionStorageKeys.KEY_ROUTE,
        location.pathname + location.search,
      )
    }
  }, [location])

  return children
}

SaveRoute.propTypes = {
  children: PropTypes.node.isRequired,
  excepts: PropTypes.array,
}

SaveRoute.defaultProps = {
  excepts: [],
}
